import { atom } from 'recoil';
import { setRecoil } from 'recoil-nexus';

import { ISelection } from 'src/constants/interfaces/bet';
import {decimalString} from "src/constants/types";

interface ISelectionsStore {
    selections: ISelection[];
    lastBetSelections: ISelection[];
};

const selectionsStore = atom<ISelectionsStore>({
    key: 'selectionsStore',
    default: {
        selections: [],
        lastBetSelections: []
    },
});

export const storeLastBetSelections = (lastBetSelections: ISelection[]) => {
    setRecoil(selectionsStore, data => ({
        ...data,
        lastBetSelections
    }));
};

export const storeChangeSelection = (eventId: number, changedSelection: ISelection | ((oldSelection: ISelection) => ISelection)) => {
    setRecoil(selectionsStore, data => ({
        ...data,
        selections: data.selections.map(item => item.event.id === eventId
            ? typeof changedSelection === 'function' ? changedSelection(item) : changedSelection
            : item)
    }));
};

export const storeChangeAllSelectionsSingleStake = (stakeValue: decimalString) => {
    setRecoil(selectionsStore, data => ({
        ...data,
        selections: data.selections.map(item => ({
            ...item,
            singleStake: stakeValue
        }))
    }));
}

export default selectionsStore;